// extracted by mini-css-extract-plugin
export var container = "index-module--container--OSMII";
export var innerContainer = "index-module--innerContainer--2UDlI";
export var firstImage = "index-module--firstImage--3KLd7";
export var grid = "index-module--grid--zwMyy";